import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { fetchServer } from "../Base/modelManager";

class CarteEditor extends React.Component {
    constructor(props){
        super(props)
     
        this.state={
            record:props.record
        }
       
    }

    onSave = () => {
        const { record } = this.state
       
        const request = {
            endPoint: this.props.apiUrl + '/carte/' + record.id,
            method: 'PATCH',
            token: this.props.JWTToken,
            params: {
                id: record.id,
                department:record.department,
                Chauffeur:record.Chauffeur,
                immatriculation:record.immatriculation,
            }
        }

        fetchServer(request,
             () => {this.props.onClose()},
            ()=>{})

    }

    onPropertyChanged = (e) => {
        const { record } = this.state


        record[e.target.name] = e.target.value
        
        this.setState({ record: { ...record } })
    }


    render() {
        const { record } = this.state


        return (
            <Container className="editorFunction">
                <Form>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Type Carte
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.typeCarte.libelle}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItemv">
                        <Form.Label column sm="4">
                        Carte
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.numero}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                        Statut
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.status.libelle}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                        Chauffeur
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.Chauffeur} name="Chauffeur" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                        Immatriculation
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.immatriculation} name="immatriculation" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                       Centre de Cout
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.department} name="department" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                </Form>


                
                
               

              

                <Row className="FormButtonBar">
                    <Col  style={{textAlign:'center'}}>
                        <Button className='frmCancel' onClick={() => this.props.onClose()}  style={{  color:   'white',  backgroundColor: '#24b5b9'}}>Annuler</Button>
                    </Col>
                    <Col style={{textAlign:'center'}}>
                        <Button  className='frmSubmit' onClick={this.onSave}  style={{  color:   'white',  backgroundColor: '#24b5b9'}}>Enregistrer</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

CarteEditor.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    record: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    onClose: PropTypes.func
};

export default connect(mapStateToProps)(CarteEditor);
